import React, { Component } from "react";
import { getNotifications } from "../../../store/actions";
import { Link } from "react-router-dom";
import renderHTML from "react-render-html";
import {
    validateEmail,
    makeid,
    getBool,
    validatePassword,
} from "../../../utils/helperFunctions";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import Cookies from "universal-cookie";
import { firebaseStorage } from "../../../firebase/firebase";
import Webcam from "react-webcam";
import appConstants from "../../../appConstants";
import version from "../../../build_version";
import responseMessages from "../../../response.json";
import Loader from "../../Loader";
import moment from "moment";
import FieldOfMedicine from "../FieldOfMedicine";
import Select from "react-dropdown-select";
import Collapse from "react-bootstrap/Collapse";
import { compress } from "../../../utils/imageOperations";
import InfiniteScroll from 'react-infinite-scroll-component';
// import { Collapse } from "bootstrap";
const cookie = new Cookies();

class Notifications extends Component {
    constructor(props) {
        super(props);
        let user = cookie.get("user", { path: "/" }) || {};

        this.state = {
            isLoading: false,
            user,
            notifications: [],
            limit: 10,
            offset: "",
            notifications: [],
            hasMore: false
        };
        this.handleFecthData = this.handleFecthData.bind(this)
    }

    async componentDidMount() {
        //TODO fetch notidications
        this.handleFecthData()
    }

    handleFecthData() {
        let { user, limit, offset, notifications } = this.state;
        getNotifications({
            userId: user.userId,
            limit,
            lastVisible: offset
        }, (err, data) => {
            if (!err) {
                notifications = notifications.concat(data.data);
                this.setState({
                    notifications,
                    offset: data.lastVisible,
                    hasMore: data.lastVisible ? true : false
                })
            } else {
                console.log("[Error fetching record]", err)
            }
        })
    }

    handleJoinCallClick(noti) {
        console.log("noti", noti)
        if (noti.taskData && noti.taskData.patientId) {
            window.location.href = `/progress/${noti.taskData.patientId}`
        }
        window.open(`/telehealth/${noti.taskId}`, "_blank", "toolbar=yes,scrollbars=yes");
    }

    render() {
        let {
            notifications
        } = this.state;
        let noNotification = true;

        let { showNotifications } = this.props
        return (
            <div style={{ height: 0, maxHeight: 0 }}>
                {this.state.isLoading ? (
                    <div className="custm-loader">
                        <Loader></Loader>
                    </div>
                ) : null}
                <Collapse in={showNotifications} dimension="width">
                    <div

                        className={`profile-seting-area`}
                        id="user-notification"
                    >
                        <div
                            className="profile-close"
                            onClick={() => {
                                this.props.showHideNotifications()
                            }}
                        >
                            <img src="/assets/img/exit.png" />
                        </div>
                        <div
                            className="activity-list"
                            style={{
                                maxHeight: "100vh",
                                overflow: 'auto',
                            }}
                            id="scrollableDiv">
                            <InfiniteScroll
                                dataLength={notifications.length} //This is important field to render the next data
                                next={this.handleFecthData}
                                hasMore={this.state.hasMore}
                                loader={<h6>Loading...</h6>}
                                scrollableTarget="scrollableDiv"
                            >
                                {
                                    notifications && notifications.length > 0
                                        ? notifications.map((act, index) => {
                                            let appointmentDateAndTime = act.taskData && act.taskData[act.taskData.type] && act.taskData[act.taskData.type].appointmentDateAndTimeUTC
                                            let withTime = false;

                                            if (appointmentDateAndTime) {
                                                let currentTime = moment();

                                                let appointmentMoment = moment.utc(appointmentDateAndTime).local();
                                                let AdterOneHour = moment.utc(appointmentDateAndTime).local().add(1, "hours");
                                                // console.log("appointmentMoment >>>>", AdterOneHour.format("YYYY-MM-DD HH:mm:ss"));
                                                if (currentTime.isBetween(appointmentMoment, AdterOneHour)) {
                                                    withTime = true;
                                                }
                                            }
                                            console.log("withTime", withTime)
                                            if (act.showJoinCall && withTime) {
                                                noNotification = false;
                                                return <div className="activity-detail-box" key={act.id}>
                                                    <div className="activity-detail notifications">
                                                        <h4>{act.recorderByData ? `${act.recorderByData.firstName} ${act.recorderByData.lastName}` : ""}</h4>
                                                        <p>{act.title}</p>
                                                        {
                                                            act.showJoinCall && withTime ? <button className="log-btn step-btn" onClick={this.handleJoinCallClick.bind(this, act)}>Join Call</button> : null
                                                        }
                                                        <span className="activity-time">
                                                            {act.sentAt ? moment.utc(act.sentAt).local().format("hh:mm a DD/MM/YY") : ""}
                                                        </span>
                                                    </div>
                                                </div>
                                            } else if (noNotification) {
                                                noNotification = false;
                                                return <p className="no-notifications-text">No notifications Yet!</p>
                                            }
                                        })
                                        : <p className="no-notifications-text">No notifications Yet!</p>
                                }
                            </InfiniteScroll>
                        </div>
                    </div>
                </Collapse>
            </div>
        );
    }
}

export default Notifications;
